'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
function objectAssign(dest, src) {
    if (!src) {
        return dest;
    }
    for (var prop in src) {
        if (src.hasOwnProperty(prop)) {
            dest[prop] = src[prop];
        }
    }
    return dest;
}

// see: https://stackoverflow.com/questions/10624057/get-name-as-string-from-a-javascript-function-reference
function functionName(func) {
    if (typeof func === 'string') {
        return func;
    }
    return (/function ([^(]*)/.exec(func + "")[1]
    );
}

var randomFuncCounter = 0;
var randomFuncPrefix = 'pchGameManagerCallback';

/**
* Wrap a given function in another global scope generated function with 
* a generated available name
*
* @ignore
*
* @param {function} func - The function to wrap
* @param {string} [name] - Provide a specific name for the wrap function rather than a generated one
*
* @returns {function} The function wrapping the given function
*/
function functionNameWrap(func, funcName) {
    if (!funcName) {
        do {
            funcName = randomFuncPrefix + ++randomFuncCounter;
        } while (window[funcName] !== undefined);
    }
    /*jshint -W061 */
    var _func;
    eval("_func = function(callee) { return window." + funcName + " = function " + funcName + "() { return callee.apply(this, arguments); }; };");
    /*jshint +W061 */
    return _func(func);
}

function queryStringify(params) {
    var s = [];
    for (var k in params) {
        if (params.hasOwnProperty(k)) {
            s.push(encodeURIComponent(k) + "=" + (params[k] !== null ? encodeURIComponent(params[k]) : ""));
        }
    }
    return s.join("&");
}

/**
* Append a query string, or query string param and val
*
* @ignore
*
* @param {string} url - The url/string to append the query string to
* @param {string} qs - The query string, or query string param name, to append
* @param {string} [val] - the query string param val, if qs is just a param name, to append
*
* @returns {string}
*/
function appendQueryString(url, qs, val) {
    return url + (url.indexOf("?") > 0 ? "&" : "?") + qs + (val === undefined ? "" : '=' + val);
}

function escapeRegExp(str) {
    // http://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}

exports.objectAssign = objectAssign;
exports.functionName = functionName;
exports.functionNameWrap = functionNameWrap;
exports.escapeRegExp = escapeRegExp;
exports.queryStringify = queryStringify;
exports.appendQueryString = appendQueryString;